"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeDateDateString = exports.serializeDateDateString = void 0;
const d = __importStar(require("schemawax"));
const schemawax_1 = require("schemawax");
const parsers_1 = require("../../parsers");
const decoder = d.string.andThen((s) => {
    let decodedValue;
    try {
        decodedValue = decodeURIComponent(s);
    }
    catch (e) {
        throw new schemawax_1.DecoderError("Invalid URI encoding");
    }
    const decodedArray = decodedValue.split(";").map((v) => v.trim());
    if (decodedArray.length !== 3) {
        throw new schemawax_1.DecoderError("Invalid format. There should be only two ';' as separators, with the following format: 'rfc3339Date;rfc3339Date;uuid'");
    }
    const [firstDateStr, secondDateStr, str] = decodedArray;
    if (firstDateStr == null) {
        throw new schemawax_1.DecoderError("No last updated date was provided in the cursor");
    }
    if (secondDateStr == null) {
        throw new schemawax_1.DecoderError("No last start time date was provided in the cursor");
    }
    if (str == null) {
        throw new schemawax_1.DecoderError("No string for the last record was provided in the cursor");
    }
    const firstDate = (0, parsers_1.rfc3339TimestampParser)(firstDateStr);
    if (isNaN(firstDate.getTime())) {
        throw new schemawax_1.DecoderError(`Invalid date provided '${firstDateStr}' in the cursor`);
    }
    const secondDate = (0, parsers_1.rfc3339TimestampParser)(secondDateStr);
    if (isNaN(secondDate.getTime())) {
        throw new schemawax_1.DecoderError(`Invalid date provided '${secondDateStr}' in the cursor`);
    }
    if (str === "") {
        throw new schemawax_1.DecoderError(`Empty string found in the cursor`);
    }
    return [firstDate, secondDate, str];
});
const serializeDateDateString = ([firstDate, secondDate, str]) => `${new Date(firstDate).toISOString()};${new Date(secondDate).toISOString()};${str}`;
exports.serializeDateDateString = serializeDateDateString;
const deserializeDateDateString = (s) => {
    return decoder.forceDecode(s);
};
exports.deserializeDateDateString = deserializeDateDateString;
//# sourceMappingURL=date-date-string.js.map